import {type StateTree} from "pinia";
import {type LearningStoreState} from "@/store/learning/state";
import {LearningTaskModel} from "~~/package/mapper/learning/model/LearningTaskModel";
import {LearningSkillModel} from "~~/package/mapper/learning/model/LearningSkillModel";
import { codeGetters } from "@/store/learning/getters/codeGetters";
import { courseGetters } from "@/store/learning/getters/courseGetters";
import { modeGetters } from "@/store/learning/getters/modeGetters";
import LearningDirectoryType
    from "~/components/Learning/LearningMiddle/LearningMultiFileCode/LearningDirectory/config/LearningDirectoryType";

export type SubmitStatus = 'notSubmitted' | 'submitted' | 'resubmitRequired';

export interface LearningStoreGetters extends StateTree {
    taskList: LearningTaskModel[];
    skillList: LearningSkillModel[];
    convertedCurrentCode: string;
    convertSavingCode: string;
    isLearning: boolean;
    isAssessment: boolean;
    isContest: boolean;
    isLevelAssessment: boolean;
    isProSkillAssure: boolean;
    firstProSkillAssureTask: LearningTaskModel;
    isFrontendLearning: boolean;
    multipleChoiceAnswerList: number[];
    getUserLearningDirectoryType: LearningDirectoryType;
    getDomainId: number | string;
    isCodeWithoutRun: boolean;
    isCodeRelatedType: boolean;
    isEmbed: boolean;
    hasUnsubmittedChange: boolean;
    submitStatus: SubmitStatus;
}

export const getters = {
    ...courseGetters,
    ...codeGetters,
    ...modeGetters
};
